/******/ (() => { // webpackBootstrap
/*!***************************!*\
  !*** ./src/js/drawing.js ***!
  \***************************/
(function () {
  if (window.lightHouse) return;
  const initDrawing = () => {
    const wrapper = document.querySelector(".draw-block");
    if (!wrapper) return;
    const canvas = wrapper.querySelector("#drawCanvas");
    const ctx = canvas.getContext("2d");
    const maskCanvas = document.createElement("canvas");
    const mCtx = maskCanvas.getContext("2d", {
      willReadFrequently: true
    });
    const buffer = document.createElement("canvas");
    const bCtx = buffer.getContext("2d");
    const progressCanvas = document.createElement("canvas");
    const pCtx = progressCanvas.getContext("2d", {
      willReadFrequently: true
    });
    const imgEmpty = new Image();
    const imgFill = new Image();
    if (!canvas.dataset.image || !canvas.dataset.fill) return;
    imgEmpty.src = canvas.dataset.image;
    imgFill.src = canvas.dataset.fill;
    let drawX = 0,
      drawY = 0,
      drawW = 0,
      drawH = 0;
    let dpr = 1;
    let totalPixels = 0;
    let lastPoint = null;
    let lastCheckTime = 0;
    Promise.all([new Promise(r => imgEmpty.onload = r), new Promise(r => imgFill.onload = r)]).then(init);
    function init() {
      window.addEventListener("resize", handleResize);
      handleResize();
    }
    function handleResize() {
      const parentW = wrapper.clientWidth;
      const parentH = wrapper.clientHeight;
      dpr = window.devicePixelRatio || 1;
      canvas.width = maskCanvas.width = buffer.width = parentW * dpr;
      canvas.height = maskCanvas.height = buffer.height = parentH * dpr;
      canvas.style.width = parentW + "px";
      canvas.style.height = parentH + "px";
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      mCtx.setTransform(dpr, 0, 0, dpr, 0, 0);
      mCtx.lineCap = "round";
      mCtx.lineJoin = "round";
      mCtx.lineWidth = 300;
      const imgNativeW = imgEmpty.width || 1374;
      const imgNativeH = imgEmpty.height || 661;
      const scale = Math.min(parentW / imgNativeW, parentH / imgNativeH);
      drawW = imgNativeW * scale;
      drawH = imgNativeH * scale;
      drawX = (parentW - drawW) / 2;
      drawY = (parentH - drawH) / 2;
      progressCanvas.width = drawW;
      progressCanvas.height = drawH;
      calculateTotalPixels();
      render();
    }
    function calculateTotalPixels() {
      pCtx.clearRect(0, 0, drawW, drawH);
      pCtx.drawImage(imgFill, 0, 0, drawW, drawH);
      const safeW = Math.max(0, Math.min(drawW, canvas.width));
      const safeH = Math.max(0, Math.min(drawH, canvas.height));
      if (safeW > 0 && safeH > 0) {
        // const data = pCtx.getImageData(0, 0, drawW, drawH).data;
        const data = pCtx.getImageData(0, 0, safeW, safeH).data;
        totalPixels = 0;
        for (let i = 3; i < data.length; i += 40) {
          if (data[i] > 20) totalPixels++;
        }
      }
    }
    function getPos(e) {
      const rect = canvas.getBoundingClientRect();
      let clientX = e.touches ? e.touches[0].clientX : e.clientX;
      let clientY = e.touches ? e.touches[0].clientY : e.clientY;
      return {
        x: clientX - rect.left,
        y: clientY - rect.top
      };
    }
    function draw(e) {
      const pos = getPos(e);
      if (lastPoint) {
        mCtx.beginPath();
        mCtx.moveTo(lastPoint.x, lastPoint.y);
        mCtx.lineTo(pos.x, pos.y);
        mCtx.stroke();
      }
      lastPoint = pos;
      requestAnimationFrame(render);
      const now = Date.now();
      if (now - lastCheckTime > 200) {
        checkProgress();
        lastCheckTime = now;
      }
    }
    function render() {
      if (!buffer || !maskCanvas || !(maskCanvas.width > 0 && maskCanvas.height > 0)) return;
      const w = canvas.width / dpr;
      const h = canvas.height / dpr;
      ctx.clearRect(0, 0, w, h);
      bCtx.clearRect(0, 0, buffer.width, buffer.height);
      ctx.drawImage(imgEmpty, drawX, drawY, drawW, drawH);
      bCtx.drawImage(maskCanvas, 0, 0);
      bCtx.globalCompositeOperation = "source-in";
      bCtx.drawImage(imgFill, drawX * dpr, drawY * dpr, drawW * dpr, drawH * dpr);
      bCtx.globalCompositeOperation = "source-over";
      ctx.save();
      ctx.setTransform(1, 0, 0, 1, 0, 0);
      ctx.drawImage(buffer, 0, 0);
      ctx.restore();
    }
    function checkProgress() {
      const tempC = document.createElement("canvas");
      tempC.width = drawW;
      tempC.height = drawH;
      const tCtx = tempC.getContext("2d");
      tCtx.drawImage(maskCanvas, drawX * dpr, drawY * dpr, drawW * dpr, drawH * dpr,
      // Source
      0, 0, drawW, drawH // Dest
      );
      tCtx.globalCompositeOperation = "source-in";
      tCtx.drawImage(imgFill, 0, 0, drawW, drawH);
      const safeW = Math.max(0, Math.min(drawW, canvas.width));
      const safeH = Math.max(0, Math.min(drawH, canvas.height));
      if (safeW > 0 && safeH > 0) {
        // const data = tCtx.getImageData(0, 0, drawW, drawH).data;
        const data = tCtx.getImageData(0, 0, safeW, safeH).data;
        let count = 0;
        for (let i = 3; i < data.length; i += 40) {
          if (data[i] > 30) count++;
        }
        const percent = count / totalPixels * 100;
        if (percent > 99.25) {
          wrapper.classList.add("--complete");
        }
      }
    }
    canvas.addEventListener("mousemove", draw);
  };
  const getPointOnPathInScreenCoords = (path, fraction = 0.5) => {
    const total = path.getTotalLength();
    const len = total * Math.max(0, Math.min(1, fraction));
    const point = path.getPointAtLength(len);
    const ctm = path.getCTM();
    if (!ctm) return {
      x: 0,
      y: 0
    };
    const screenPoint = point.matrixTransform(ctm);
    return {
      x: screenPoint.x,
      y: screenPoint.y
    };
  };
  const positionElement = (element, screenX, screenY, offsetX = 0, offsetY = 0, centerX = true) => {
    let x = screenX + offsetX;
    let y = screenY + offsetY;
    element.style.position = "absolute";
    element.style.left = `${x}px`;
    element.style.top = `${y}px`;
  };
  if (window.innerWidth < 1080) return;
  initDrawing();
  const path = document.querySelector(".draw-block .ref .cookie");
  const message = document.querySelector(".draw-block .draw-message");
  if (path && message) {
    const point = getPointOnPathInScreenCoords(path, 0.42);
    positionElement(message, point.x, point.y, 0, 0);
  }
})();
/******/ })()
;